/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type BaseWebhookConfiguration = {
  /**
   * URL of the webhook.
   */
  webhookUrl: string;
  /**
   * Authorization type
   */
  authorizationType: BaseWebhookConfiguration.authorizationType;
  /**
   * Enable telemetry
   */
  telemetryEnabled?: boolean;
  /**
   * List of enabled events.
   */
  enabledEvents?: Array<'ALL' | 'BATTERY_STATUS' | 'CO_STATUS' | 'CO_SELFTEST' | 'DEVICE_STATUS' | 'SMOKE_STATUS' | 'HUMID_STATUS' | 'HUMID_PREDICTION_STATUS' | 'TEMP_STATUS' | 'TEMP_PREDICTION_STATUS' | 'VOC_STATUS' | 'VOC_PREDICTION_STATUS' | 'COVER_STATUS' | 'FW_DOWNLOAD' | 'FW_UPDATE' | 'SIREN_STATUS' | 'LOG_SENDING' | 'EXTERNAL_POWER' | 'SIGNAL_STATUS' | 'PRESSURE_STATUS' | 'HEALTH_STATUS' | 'SMOKE_SENSOR_STATUS' | 'DEVICE_SELF_TEST' | 'CO_SENSOR_SELF_TEST' | 'DOWNLINK_STATUS' | 'FIRMWARE_UPDATE_STATUS' | 'LOG_STATUS' | 'NETWORK_STATUS' | 'PAIRING_STATUS' | 'DEVICE_REMINDER' | 'CO2_STATUS'>;
};
export namespace BaseWebhookConfiguration {
  /**
   * Authorization type
   */
  export enum authorizationType {
    API_KEY = 'API_KEY',
  }
}

